<template>
    <div class="lg:p-12 bg-gray-100 rounded p-4">
        <h2 class="text-3xl font-bold text-center text-themeColor mb-4">
            {{ $t('account.register.new_account') }}
        </h2>

        <b-loading
            :is-full-page="true"
            v-model="loading"
            :can-cancel="false"
        ></b-loading>

        <section class="" v-if="!result">
            <div class="mb-4">
                <label class="block text-gray-700 text-base font-bold mb-2">
                    {{ $t('account.name') }}
                    <span class="text-red-500">( * )</span>
                </label>
                <input
                    v-model="user.name"
                    class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
                    type="text"
                    placeholder="Patrick Martin"
                />
            </div>

            <div class="mb-4">
                <label class="block text-gray-700 text-base font-bold mb-2">
                    {{ $t('account.email') }}
                    <span class="text-red-500">( * )</span>
                </label>
                <input
                    v-model="user.email"
                    class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
                    type="email"
                    placeholder="patrickmartin@domaine.fr"
                />
            </div>

            <div class="mb-4">
                <label
                    class="block text-gray-700 text-base font-bold mb-2"
                    for="username"
                >
                    {{ $t('account.register.phone') }}
                </label>
                <input
                    v-model="user.phone"
                    class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
                    type="tel"
                    placeholder="+33 6 06 06 06 06"
                />
            </div>

            <div class="mb-4">
                <label
                    class="block text-gray-700 text-base font-bold mb-2"
                    for="username"
                >
                    {{ $t('account.register.password') }}
                    <span class="text-red-500">( * )</span>
                </label>
                <input
                    v-model="user.password"
                    class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
                    type="password"
                    placeholder="********"
                />
            </div>

            <div class="mb-4">
                <label
                    class="block text-gray-700 text-base font-bold mb-2"
                    for="username"
                >
                    {{ $t('account.register.confirm_password') }}
                    <span class="text-red-500">( * )</span>
                </label>
                <input
                    v-model="user.password_confirmation"
                    class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
                    type="password"
                    placeholder="********"
                />
            </div>

            <div class="mt-5">
                <button
                    id="registerBtn"
                    @click.prevent="doRegister"
                    class="text-base font-bold text-center bg-themeColor text-white hover-bg-secondaryColor rounded w-full py-3"
                >
                    {{ $t('account.register.register') }}
                </button>
            </div>
        </section>
        <div v-else>
            <h4
                id="confirmMailTitle"
                class="text-center text-xl font-bold mt-4"
            >
                {{ $t('account.register.confirm_mail') }}
            </h4>
            <h4 class="text-lg font-semibold text-center mt-2">
                {{ $t('account.register.valid_registration') }}
            </h4>

            <p class="text-base text-center mt-4">
                {{ $t('account.register.mail_instruction') }}
            </p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: 'Register',
    data() {
        return {
            result: false,
            loading: false
        }
    },
    computed: {
        ...mapState('auth', {
            user: (state) => state.newUser
        })
    },
    methods: {
        ...mapActions('auth', ['register']),
        doRegister() {
            this.loading = true

            if (!this.user.phone) delete this.user.phone
            if (
                Object.values(this.user).every(
                    (field) => field && field.length > 0
                )
            ) {
                this.register(this.user)
                    .then(() => {
                        this.result = true
                    })
                    .catch((e) => {
                        this.$store.dispatch('toastError', e)
                        throw new Error(e)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                this.$store.dispatch('toast', {
                    type: 'error',
                    title: this.$t('error.validation.not_send'),
                    message: this.$t('error.validation.fill_all')
                })
                this.loading = false
            }
        }
    },
    mounted() {
        if (this.$store.state.auth.isConnected) {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped></style>
